import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  customerData: CustomerData;
  exp: number;
}

export interface CustomerData {
  Id: number;
  FirstName: string;
  LastName: string;
  Email: string;
  isVerify: boolean;
  PhoneNumber: string;
  KindOfDNI: string;
  DNI: string;
  ISO2Country: string;
  Code?: string;
  isComplete: boolean;
  hasPassword?: boolean;
}

class TokenService {
  getToken(): string | null {
    return localStorage.getItem("authToken");
  }

  removeToken(): void {
    localStorage.removeItem("authToken");
  }

  setToken(token: string): void {
    localStorage.setItem("authToken", token);
  }

  getCustomerDataToken(): DecodedToken | null {
    const token = this.getToken();
    if (token) {
      try {
        const decoded: DecodedToken = jwtDecode(token);

        // 1. Comprobar si el token ha expirado
        if (decoded.exp * 1000 < Date.now()) {
          console.error("Token has expired.");
          this.removeToken(); // Limpiar el token vencido
          return null;
        }

        // 2. Si customerData es un string, conviértelo a objeto
        if (decoded && typeof decoded.customerData === "string") {
          // Aseguramos que el parseo se haga de forma segura
          decoded.customerData = JSON.parse(decoded.customerData as any);
        }

        return decoded;
      } catch (error) {
        console.error("Failed to decode token:", error);
        this.removeToken(); // Limpiar token inválido
        return null;
      }
    }
    return null;
  }

  isUserVerified(): boolean {
    const data = this.getCustomerDataToken();
    return data?.customerData?.isVerify === true;
  }
}

export const tokenService = new TokenService();
